var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "kanban-list" } }, [
    _c(
      "div",
      { staticClass: "kanban-task-table" },
      [
        _c("a-table", {
          attrs: {
            columns: _vm.columns,
            "data-source": _vm.tasks,
            pagination: false,
          },
          scopedSlots: _vm._u([
            {
              key: "pipelineStage",
              fn: function (pipelineStage, data) {
                return _c("span", {}, [
                  _c(
                    "div",
                    {
                      staticClass: "supsis-tag-el",
                      style: { "--pipeline-color": data.pipelineStage.color },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(data.pipelineStage.name) +
                          "\n                "
                      ),
                    ]
                  ),
                ])
              },
            },
            {
              key: "owner",
              fn: function (owner, data) {
                return _c("span", {}, [
                  _c(
                    "div",
                    { staticClass: "agent-detail" },
                    [
                      owner
                        ? _c("Avatar", {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                              },
                            ],
                            key: owner,
                            attrs: {
                              size: 25,
                              src: _vm.users[owner].gravatar,
                              username: _vm.users[owner].name,
                              content: _vm.users[owner].name,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.users[owner]
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: { content: _vm.users[owner].name },
                                  expression: "{content: users[owner].name}",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.users[owner].name.substring(0, 8) +
                                      "..."
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              },
            },
            {
              key: "assignees",
              fn: function (assignees, data) {
                return _c("span", {}, [
                  _c(
                    "div",
                    { staticClass: "agent-detail" },
                    [
                      _vm.users[assignees[0]]
                        ? _c("Avatar", {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                },
                                expression:
                                  "{\n                            followCursor: true,\n                            placement: 'bottom-end',\n                        }",
                              },
                            ],
                            key: assignees[0],
                            attrs: {
                              size: 25,
                              src: _vm.users[assignees[0]].gravatar,
                              username: _vm.users[assignees[0]].name,
                              content: _vm.users[assignees[0]].email,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.users[assignees[0]]
                        ? _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.users[assignees[0]].name,
                                  },
                                  expression:
                                    "{content: users[assignees[0]].name}",
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.users[assignees[0]].name.substring(
                                      0,
                                      8
                                    ) + "..."
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              },
            },
            {
              key: "createdAt",
              fn: function (createdAt) {
                return _c("span", {}, [
                  _vm._v(" " + _vm._s(_vm.formatDate(createdAt)) + " "),
                ])
              },
            },
            {
              key: "startDate",
              fn: function (startDate) {
                return _c("span", {}, [
                  _vm._v(" " + _vm._s(_vm.formatDate(startDate)) + " "),
                ])
              },
            },
            {
              key: "endDate",
              fn: function (endDate) {
                return _c("span", {}, [
                  _vm._v(_vm._s(_vm.formatDate(endDate)) + " "),
                ])
              },
            },
          ]),
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "paginator" },
          [
            _c("a-pagination", {
              attrs: {
                "page-size": _vm.perPage,
                pageSizeOptions: [5, 10, 20, 50, 100],
                "show-size-changer": "",
                total: _vm.totalCount,
              },
              on: {
                "update:pageSize": function ($event) {
                  _vm.perPage = $event
                },
                "update:page-size": function ($event) {
                  _vm.perPage = $event
                },
              },
              model: {
                value: _vm.page,
                callback: function ($$v) {
                  _vm.page = $$v
                },
                expression: "page",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }